import { PROMOTIONS, TECHNOLOGY } from "../../lib/data";

const PromotionRow = ({ promo, index }) => (
  <div
    data-testid={`promo-${index}`}
    className="hairline-b border-b py-5 md:py-7 grid grid-cols-12 items-baseline gap-4 reveal"
    style={{ transitionDelay: `${index * 80}ms` }}
  >
    <div className="col-span-3 md:col-span-2 font-mono text-sm md:text-base text-[var(--muted)]">
      {promo.year}
    </div>
    <div className="col-span-1 font-mono text-xs opacity-40">→</div>
    <div className="col-span-8 md:col-span-9 text-xl md:text-3xl font-bold tracking-tight">
      {promo.title}
    </div>
  </div>
);

const TechnologyChips = ({ items }) => (
  <div className="mt-14 md:mt-20">
    <div className="text-[10.5px] tracking-[0.22em] uppercase opacity-50 mb-5">
      Tooling
    </div>
    <div className="flex flex-wrap gap-2">
      {items.map((t) => (
        <span
          key={t}
          className="inline-block text-xs md:text-sm tracking-tight border hairline px-3 py-1.5"
        >
          {t}
        </span>
      ))}
    </div>
  </div>
);

const EducationLine = () => (
  <div className="mt-10 md:mt-14 hairline-t border-t pt-6">
    <div className="text-[10.5px] tracking-[0.22em] uppercase opacity-50 mb-3">
      Education
    </div>
    <div className="text-lg md:text-2xl font-medium tracking-tight">
      Bachelor of Business Administration —{" "}
      <span className="text-[var(--muted)]">
        Jain University, Bengaluru · 2018
      </span>
    </div>
  </div>
);

export const Promotions = () => {
  return (
    <section data-testid="promotions-section" className="hairline-b border-b">
      <div className="max-w-[1480px] mx-auto px-5 md:px-10 py-16 md:py-28 grid grid-cols-12 gap-8 md:gap-12">
        <div className="col-span-12 md:col-span-4">
          <div className="text-[10.5px] tracking-[0.22em] uppercase opacity-50 mb-2">
            Promotion Story
          </div>
          <h2 className="text-3xl md:text-5xl font-bold tracking-tight leading-[0.95] mb-6">
            Four promotions<br />in six years.
          </h2>
          <p className="text-base md:text-lg text-[var(--muted)] leading-relaxed max-w-prose">
            A career built one brief at a time — inside the same agency.
          </p>
        </div>

        <div className="col-span-12 md:col-span-7 md:col-start-6">
          <div className="space-y-0 hairline-t border-t">
            {PROMOTIONS.map((p, i) => (
              <PromotionRow
                key={`${p.year}-${p.title}`}
                promo={p}
                index={i}
              />
            ))}
          </div>
          <TechnologyChips items={TECHNOLOGY} />
          <EducationLine />
        </div>
      </div>
    </section>
  );
};
